import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { BookmarkIcon, FlagIcon, ReadingIcon } from 'rebook/apps/base/components/icons/BookIcon';

import styles from './style.scss';


const BookStatusShield = ({ readingStatus, extraClassName, type }) => {
  const isAudioBook = type==='audio';
  const bookStatus = [
    null,
    () => (
      <span className={styles.text}>
        <BookmarkIcon className={styles.icon} /> {`Хочу ${isAudioBook ? 'прослушать' : 'прочитать'}`}
      </span>
    ),
    () => (
      <span className={styles.text}>
        <ReadingIcon className={styles.icon} /> {`${isAudioBook ? 'Cлушаю' : 'Читаю'}`}
      </span>
    ),
    () => (
      <span className={styles.text}>
        <FlagIcon className={styles.icon} /> {`${isAudioBook ? 'Прослушано' : 'Прочитано'}`}
      </span>
    ),
  ];

  return (
    <div className={classNames(extraClassName, styles.shield)}>
      {bookStatus[readingStatus]()}
    </div>
  );
};

BookStatusShield.propTypes = {
  readingStatus: PropTypes.number.isRequired,
  extraClassName: PropTypes.string,
  type: PropTypes.string,
};

BookStatusShield.defaultProps = {
  readingStatus: null,
  extraClassName: '',
  type: 'text',
};

export default BookStatusShield;
